import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import * as actionTypes from '../constants/scenario-evaluation-edit-action-types';

import type {Map} from 'immutable';
import type {ActionsMap} from 'redux-store';

export type ScenarioEvaluationEditStore = {
    evaluation: Map<unknown, unknown>;
};

const initialState = (): ScenarioEvaluationEditStore => {
    return {
        evaluation: Immutable.Map(),
    };
};

const actionsMap: ActionsMap<ScenarioEvaluationEditStore> = {
    [actionTypes.FETCH_SCENARIO_EVALUATION_SUCCESS]: (state, action) => {
        return {
            evaluation: action.data,
        };
    },

    [actionTypes.DISPOSE_STORE]: () => {
        return initialState();
    },
};

export default createReducer<ScenarioEvaluationEditStore>(initialState(), actionsMap);
